export default __webpack_public_path__ + "static/media/clio-gallery-4.b49818de.jpg";